import { GaugeConfig } from "../types";

export const GaugeNeedle = ({
  rotation,
  config
}: {
  rotation: number;
  config: GaugeConfig;
}) => {
  const { center, radius } = config;
  // margin from the needle to the arcs
  const needleDistance = radius - 20;

  return (
    <g
      style={{
        transform: `rotate(${rotation}deg)`,
        transformOrigin: `${center.x}px ${center.y}px`,
        transition: "transform 0.6s ease-out"
      }}
    >
      {/* needle head */}
      <polygon
        points={`${center.x},${center.y - needleDistance - 6} ${center.x - 6},${center.y - needleDistance + 5} ${center.x + 5},${center.y - needleDistance + 5}`}
        fill="#1c1d22"
        strokeLinejoin="round"
        stroke="#1c1d22"
        strokeWidth="3"
      />
    </g>
  );
};
